// src/pages/Operator/IbadahMinggu/IbadahMinggu.jsx
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
// Path yang dikoreksi (keluar 3 tingkat, masuk ke komponen)
import { NavBarLogin } from "../../../components";
// Path yang dikoreksi (keluar 3 tingkat, masuk ke config/firebase)
import { db } from "../../../config/firebase";
import { ref, set, onValue } from "firebase/database";
import "./ibadahMinggu.scss"; // Menggunakan SCSS yang akan kita definisikan

const IbadahMinggu = () => {
  const navigate = useNavigate();
  // 💡 TAMBAH 'pelayan' di state sesi
  const [sesi1, setSesi1] = useState({ waktu: "", deskripsi: "", pelayan: "" });
  const [sesi2, setSesi2] = useState({ waktu: "", deskripsi: "", pelayan: "" });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  // Bagian Statis Waktu untuk Auto-Format
  const STATIC_TIME_PREFIX = "Setiap Minggu | Pkl. ";
  const STATIC_TIME_SUFFIX = " WITA";

  // 1. Fungsi Auto-Format Jam (Tidak Berubah)
  const formatTimeInput = (rawInput) => {
    const digits = rawInput.replace(/\D/g, "").substring(0, 4);

    if (digits.length === 4) {
      const hour = digits.substring(0, 2);
      const minute = digits.substring(2, 4);

      const hourInt = parseInt(hour);
      const minuteInt = parseInt(minute);

      if (hourInt >= 0 && hourInt <= 23 && minuteInt >= 0 && minuteInt <= 59) {
        return `${STATIC_TIME_PREFIX}${hour}.${minute}${STATIC_TIME_SUFFIX}`;
      }
    }
    return rawInput;
  };

  // 2. Handler Input Waktu (Tidak Berubah)
  const handleTimeChange = (e, setSesi, sesiState) => {
    const value = e.target.value;
    const rawTime = value.replace(/\D/g, ""); // Ambil hanya angka

    if (rawTime.length === 4) {
      const formattedValue = formatTimeInput(rawTime);
      setSesi({ ...sesiState, waktu: formattedValue });
    } else {
      setSesi({ ...sesiState, waktu: rawTime });
    }
  };

  // 3. Fungsi Validasi Waktu (Tidak Berubah)
  const validateWaktu = (waktu) => {
    if (!waktu.trim()) {
      return false;
    }
    const regex = /Pkl\. \d{2}\.\d{2} WITA/i;
    return regex.test(waktu);
  };

  // 4. Ambil Data Awal (Pre-fill Form)
  useEffect(() => {
    const jadwalRef = ref(db, "jadwal_ibadah_minggu");
    onValue(
      jadwalRef,
      (snapshot) => {
        const data = snapshot.val();
        if (data) {
          // 💡 Pastikan mengambil data 'pelayan' juga
          setSesi1(data.sesi1 || { waktu: "", deskripsi: "", pelayan: "" });
          setSesi2(data.sesi2 || { waktu: "", deskripsi: "", pelayan: "" });
        }
      },
      {
        onlyOnce: true,
      }
    );
  }, []);

  // 5. Kosongkan Form
  const clearForm = () => {
    // 💡 Reset 'pelayan'
    setSesi1({ waktu: "", deskripsi: "", pelayan: "" });
    setSesi2({ waktu: "", deskripsi: "", pelayan: "" });
  };

  // 6. Handler Submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");

    // VALIDASI AKHIR: Memastikan format telah sesuai
    if (!validateWaktu(sesi1.waktu) || !validateWaktu(sesi2.waktu)) {
      setMessage(
        "❌ Mohon masukkan 4 digit angka yang valid untuk Sesi 1 dan Sesi 2."
      );
      setLoading(false);
      setTimeout(() => setMessage(""), 5000);
      return;
    }

    const jadwalRef = ref(db, "jadwal_ibadah_minggu");

    try {
      // 💡 SIMPAN DATA 'pelayan' ke Firebase
      await set(jadwalRef, {
        sesi1: {
          waktu: sesi1.waktu,
          deskripsi: sesi1.deskripsi.trim() || "Ibadah Minggu Sesi 1",
          pelayan: sesi1.pelayan.trim() || "Pelayan Firman belum diatur", // Simpan pelayan
        },
        sesi2: {
          waktu: sesi2.waktu,
          deskripsi: sesi2.deskripsi.trim() || "Ibadah Minggu Sesi 2",
          pelayan: sesi2.pelayan.trim() || "Pelayan Firman belum diatur", // Simpan pelayan
        },
      });
      setMessage("✅ Jadwal berhasil diupdate!");
      clearForm(); // Kosongkan form setelah sukses
    } catch (error) {
      console.error("Gagal mengupdate jadwal:", error);
      setMessage("❌ Gagal mengupdate jadwal. Cek konsol untuk detail.");
    } finally {
      setLoading(false);
      setTimeout(() => setMessage(""), 5000);
    }
  };

  return (
    <div className="ibadah-minggu-page">
      <NavBarLogin />
      <section className="update-form-section">
        {/* Bagian Header dan Tombol Kembali */}
        <div className="form-header-action">
          <button
            onClick={() => navigate("/operator")}
            className="stylish-back-button"
            disabled={loading}
          >
            <span aria-hidden="true">←</span> Dashboard Operator
          </button>
          <div className="header-content">
            <h2>🗓️ Update Jadwal Ibadah Minggu</h2>
            <p>
              Silakan masukkan **4 digit angka** waktu (misalnya **0900**) untuk
              format otomatis.
            </p>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="jadwal-form">
          {/* Sesi 1 */}
          <h3>Sesi 1</h3>
          <div className="form-group">
            <label htmlFor="waktu-s1">
              Waktu (Input **HHMM**, misal: **0900**):
            </label>
            <input
              id="waktu-s1"
              type="text"
              value={sesi1.waktu.replace(/[^0-9]/g, "").substring(0, 4)}
              onChange={(e) => handleTimeChange(e, setSesi1, sesi1)}
              required
              placeholder="Input 4 digit angka, misal: 0900"
              maxLength="4"
            />
            {sesi1.waktu.length > 0 && (
              <small className="time-preview">
                Akan tersimpan sebagai: **{sesi1.waktu}**
              </small>
            )}
          </div>
          <div className="form-group">
            <label htmlFor="deskripsi-s1">Deskripsi/Nama Ibadah:</label>
            <input
              id="deskripsi-s1"
              type="text"
              value={sesi1.deskripsi}
              onChange={(e) =>
                setSesi1({ ...sesi1, deskripsi: e.target.value })
              }
              placeholder="Ibadah Minggu Sesi 1"
            />
          </div>

          {/* 💡 INPUT PELAYAN SESI 1 BARU */}
          <div className="form-group">
            <label htmlFor="pelayan-s1">Nama Pelayan Firman:</label>
            <input
              id="pelayan-s1"
              type="text"
              value={sesi1.pelayan}
              onChange={(e) => setSesi1({ ...sesi1, pelayan: e.target.value })}
              placeholder="Pdt. Nama Lengkap"
            />
          </div>
          {/* End Input Pelayan Sesi 1 */}

          {/* Sesi 2 */}
          <h3>Sesi 2</h3>
          <div className="form-group">
            <label htmlFor="waktu-s2">
              Waktu (Input **HHMM**, misal: **1800**):
            </label>
            <input
              id="waktu-s2"
              type="text"
              value={sesi2.waktu.replace(/[^0-9]/g, "").substring(0, 4)}
              onChange={(e) => handleTimeChange(e, setSesi2, sesi2)}
              required
              placeholder="Input 4 digit angka, misal: 1800"
              maxLength="4"
            />
            {sesi2.waktu.length > 0 && (
              <small className="time-preview">
                Akan tersimpan sebagai: **{sesi2.waktu}**
              </small>
            )}
          </div>
          <div className="form-group">
            <label htmlFor="deskripsi-s2">Deskripsi/Nama Ibadah:</label>
            <input
              id="deskripsi-s2"
              type="text"
              value={sesi2.deskripsi}
              onChange={(e) =>
                setSesi2({ ...sesi2, deskripsi: e.target.value })
              }
              placeholder="Ibadah Minggu Sesi 2"
            />
          </div>

          {/* 💡 INPUT PELAYAN SESI 2 BARU */}
          <div className="form-group">
            <label htmlFor="pelayan-s2">Nama Pelayan Firman:</label>
            <input
              id="pelayan-s2"
              type="text"
              value={sesi2.pelayan}
              onChange={(e) => setSesi2({ ...sesi2, pelayan: e.target.value })}
              placeholder="Pdt. Nama Lengkap"
            />
          </div>
          {/* End Input Pelayan Sesi 2 */}

          <button type="submit" disabled={loading}>
            {loading ? "Menyimpan..." : "Simpan Perubahan Jadwal"}
          </button>

          {message && (
            <p
              className={`message ${
                message.startsWith("✅") ? "success" : "error"
              }`}
            >
              {message}
            </p>
          )}
        </form>
      </section>
    </div>
  );
};

export default IbadahMinggu;
